module.exports = __webpack_public_path__ + "static/media/arrow-circle-empty-light.a3881be4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-circle-empty-light.svg
// module id = 67
// module chunks = 0